module.exports = __webpack_public_path__ + "assets/img/算法分批.5ebfdd5a.jpg";